import { __exports as factory } from "../../../../../_virtual/factory.js";
import { __require as requireCache } from "./local/cache.js";
import { __require as requireClient } from "./local/client.js";
import { __require as requireClient$1 } from "./remote/client.js";
var hasRequiredFactory;
function requireFactory() {
  if (hasRequiredFactory) return factory;
  hasRequiredFactory = 1;
  Object.defineProperty(factory, "__esModule", { value: true });
  factory.Experiment = void 0;
  const cache_1 = requireCache();
  const client_1 = requireClient();
  const client_2 = requireClient$1();
  const remoteEvaluationInstances = {};
  const localEvaluationInstances = {};
  const initialize = (apiKey, config) => {
    return initializeRemote(apiKey, config);
  };
  const initializeRemote = (apiKey, config) => {
    const instanceKey = getInstanceKey(apiKey, config === null || config === void 0 ? void 0 : config.instanceName);
    if (!remoteEvaluationInstances[instanceKey]) {
      remoteEvaluationInstances[instanceKey] = new client_2.RemoteEvaluationClient(apiKey, config);
    }
    return remoteEvaluationInstances[instanceKey];
  };
  const initializeLocal = (apiKey, config) => {
    const instanceKey = getInstanceKey(apiKey, config === null || config === void 0 ? void 0 : config.instanceName);
    if (!localEvaluationInstances[instanceKey]) {
      localEvaluationInstances[instanceKey] = new client_1.LocalEvaluationClient(apiKey, config, new cache_1.InMemoryFlagConfigCache());
    }
    return localEvaluationInstances[instanceKey];
  };
  const getInstanceKey = (apiKey, instanceName) => {
    return `${apiKey}-${instanceName}`;
  };
  factory.Experiment = {
    initialize,
    initializeRemote,
    initializeLocal
  };
  return factory;
}
export {
  requireFactory as __require
};
//# sourceMappingURL=factory.js.map
